/* eslint-disable import/no-extraneous-dependencies */
import {
  Link as ChakraLink,
  Box,
  Grid,
  HStack,
  Image,
  VStack,
  StackProps,
} from "@chakra-ui/react";
import qs from "query-string";
import { Link } from "react-router-dom";
import newIcon from "./assets/new-icon.svg";
import rankingIcon from "./assets/ranking-icon.svg";

type Props = {} & StackProps;

export const HeaderMenuContent = ({ ...stackProps }: Props) => {
  return (
    <VStack
      gap="2"
      maxWidth={{ lg: "380px" }}
      maxHeight={{ lg: "75vh" }}
      overflowY="scroll"
      scrollbarWidth="none"
      bg="backgroundSecondary"
      h="100%"
      {...stackProps}
    >
      {/* Ranking / new stories */}
      <HStack
        w="100%"
        h="56px"
        minH="56px"
        justifyContent="space-around"
        gap="0"
        bg="backgroundPrimary"
      >
        <ChakraLink
          href={getGenreRankingUrl("horror")}
          _hover={{ opacity: "0.8" }}
          _focus={{
            outline: "none",
          }}
        >
          <HStack>
            <Image src={rankingIcon} alt="ランキング" w="32px" h="32px" />
            ランキング
          </HStack>
        </ChakraLink>
        <ChakraLink href="/stories" _hover={{ opacity: "0.8" }}>
          <HStack>
            <Image src={newIcon} alt="新着" w="32px" h="32px" />
            新着
          </HStack>
        </ChakraLink>
      </HStack>

      {/* Genres */}
      <Box bg="backgroundPrimary">
        <Grid
          w="100%"
          templateColumns={{ base: "repeat(2, 1fr)" }}
          fontWeight="700"
          textAlign="center"
          gap="2px"
          p="0"
          bg="backgroundSecondary"
        >
          {GenrePaths.map((genre) => (
            <ChakraLink
              href={getGenreRankingUrl(genre.path)}
              key={genre.path}
              m="0"
              p="15px 12px"
              _hover={{
                opacity: "0.8",
              }}
              textAlign="center"
              justifyContent="center"
              fontSize={13}
              bg="backgroundPrimary"
            >
              {genre.genre}
            </ChakraLink>
          ))}
          <Box flex={1} bg="backgroundPrimary" />
        </Grid>
      </Box>

      {/* User Menu */}
      <VStack
        p="26px 0 0 24px"
        fontSize={13}
        justifyContent="left"
        alignItems="flex-start"
        w="100%"
        h="100%"
        textAlign="left"
        bg="backgroundPrimary"
      >
        <ChakraLink
          href="/my_page"
          h="36px"
          _hover={{
            opacity: "0.8",
          }}
        >
          マイページ／設定
        </ChakraLink>
        <Link to="/logout">
          <Box
            h="36px"
            _hover={{
              opacity: "0.8",
              cursor: "pointer",
            }}
          >
            ログアウト
          </Box>
        </Link>
      </VStack>
    </VStack>
  );
};

const getGenreRankingUrl = (genreName: string) =>
  qs.stringifyUrl(
    {
      url: `/genre/${genreName}/ranking`,
    },
    {
      skipNull: true,
    },
  );

export const Genre = {
  GENRE_HORROR_THRILLER: "ホラー・ミステリー",
  GENRE_ROMANCE: "恋愛・ロマンス",
  GENRE_BL: "BL",
  GENRE_DRAMA: "ドラマ",
  GENRE_FANTASY: "ファンタジー・異世界・SF",
  GENRE_ROMANCE_FANTASY: "ロマンスファンタジー",
  GENRE_COMEDY: "コメディ",
  GENRE_FANFIC: "二次創作・夢小説",
  GENRE_OTHER: "雑談、その他",
} as const;
export type Genre = (typeof Genre)[keyof typeof Genre];

export const GenrePaths = [
  {
    genre: Genre.GENRE_HORROR_THRILLER,
    path: "horror",
  },
  {
    genre: Genre.GENRE_ROMANCE,
    path: "romance",
  },
  {
    genre: Genre.GENRE_BL,
    path: "bl",
  },
  {
    genre: Genre.GENRE_DRAMA,
    path: "drama",
  },
  {
    genre: Genre.GENRE_FANTASY,
    path: "fantasy",
  },
  {
    genre: Genre.GENRE_ROMANCE_FANTASY,
    path: "fantasy-romance",
  },
  {
    genre: Genre.GENRE_COMEDY,
    path: "comedy",
  },
];
